import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { ReactComponent as AdminIcon } from '~assets/menu/admin.svg';
import { ReactComponent as BannerIcon } from '~assets/menu/banner.svg';
import { ReactComponent as ClientIcon } from '~assets/menu/cliente-ico.svg';
import { ReactComponent as RegisterIcon } from '~assets/menu/register.svg';
import { ReactComponent as SupplierIcon } from '~assets/menu/supplier.svg';
import { ReactComponent as TruckIcon } from '~assets/menu/truck-ico.svg';
import { ReactComponent as VcardIcon } from '~assets/menu/vcard.svg';

import { ReactComponent as AuthorIcon } from '~assets/menu/author.svg';
import { ReactComponent as BlogIcon } from '~assets/menu/blog.svg';
import { ReactComponent as PostIcon } from '~assets/menu/post.svg';
import { ReactComponent as PostCategoryIcon } from '~assets/menu/post_category.svg';

import { ReactComponent as CouponIcon } from '~assets/menu/coupon.svg';
import { ReactComponent as EcommerceIcon } from '~assets/menu/ecommerce.svg';
import { ReactComponent as SalesIcon } from '~assets/menu/sales.svg';

import { ReactComponent as CampaignIcon } from '~assets/menu/campaign.svg';

import { ReactComponent as GoogleAnalyticsIcon } from '~assets/menu/google_analytics.svg';
import { ReactComponent as SalesReportIcon } from '~assets/menu/sales_report.svg';

import { ReactComponent as ZapIcon } from '~assets/menu/campaign.svg';
import { ReactComponent as CnaeIcon } from '~assets/menu/categories.svg';
import { ReactComponent as DindinIcon } from '~assets/menu/dindin.svg';
import { ReactComponent as FinancialIcon } from '~assets/menu/financial.svg';
import { ReactComponent as SupportIcon } from '~assets/menu/support.svg';

import { ReactComponent as WebsiteInfoIcon } from '~assets/menu/website_info.svg';

import { ReactComponent as BrandIcon } from '~assets/menu/brand.svg';
import { ReactComponent as CategoriesIcon } from '~assets/menu/categories.svg';
import { ReactComponent as HighlightIcon } from '~assets/menu/highlight.svg';
import { ReactComponent as IdeoIcon } from '~assets/menu/ideia.svg';
import { ReactComponent as ImportingIcon } from '~assets/menu/importing.svg';
import { ReactComponent as ProductIcon } from '~assets/menu/product.svg';
import { ReactComponent as RegisterSupplierIcon } from '~assets/menu/representada.svg';
import { Container, MenuItem, SectionMenuItem } from './styles';

interface Props {
  minimal?: boolean;
}

export function Menu({ minimal = false }: Props) {
  const { pathname } = useLocation();

  const isOnRegisterRoute = useMemo(() =>
    pathname.includes('register')
    , [pathname])

  const isOnBlogRoute = useMemo(() =>
    pathname.includes('blog')
    , [pathname])

  const isOnStoreRoute = useMemo(() =>
    pathname.includes('store')
    , [pathname])

  const isOnFinancesRoute = useMemo(() =>
    pathname.includes('finances')
    , [pathname])

  const isOnSupportRoute = useMemo(() =>
    pathname.includes('support')
    , [pathname])

  const isOnSettingsRoute = useMemo(() =>
    pathname.includes('settings')
    , [pathname])

  const isOnMarketingRoute = useMemo(() =>
    pathname.includes('marketing')
    , [pathname])

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <Container minimal={minimal}>
        <SectionMenuItem
          to="/admin-dashboard"
          minimal={minimal}
          selected={pathname === "/admin-dashboard"}
          orange
          style={{
            borderRadius: '0.5rem 0.5rem 0 0'
          }}
        >
          <GoogleAnalyticsIcon />
          {!minimal && <p>Dashboard</p>}
        </SectionMenuItem>
        <SectionMenuItem
          to="/marketing"
          minimal={minimal}
          selected={isOnMarketingRoute}
          orange
        >
          <ZapIcon />
          {!minimal && <p>Marketing</p>}
        </SectionMenuItem>
        {isOnMarketingRoute &&
          <>
            <MenuItem
              to="/marketing/segments"
              minimal={minimal}
              selected={pathname.includes("/marketing/segments")}
            >
              <ClientIcon />
              {!minimal && <p>Segmentos</p>}
            </MenuItem>
            <MenuItem
              to="/marketing/tags"
              minimal={minimal}
              selected={pathname.includes("/marketing/tags")}
            >
              <HighlightIcon />
              {!minimal && <p>Tags</p>}
            </MenuItem>
            <MenuItem
              to="/marketing/campaigns"
              minimal={minimal}
              selected={pathname.includes("/marketing/campaigns")}
            >
              <CampaignIcon />
              {!minimal && <p>Campanhas</p>}
            </MenuItem>
            <MenuItem
              to="/marketing/templates"
              minimal={minimal}
              selected={pathname.includes("/marketing/templates")}
            >
              <PostIcon />
              {!minimal && <p>Templates</p>}
            </MenuItem>
            <MenuItem
              to="/marketing/workflows"
              minimal={minimal}
              selected={pathname.includes("/marketing/workflows")}
            >
              <GoogleAnalyticsIcon />
              {!minimal && <p>Workflows</p>}
            </MenuItem>
          </>
        }
        <SectionMenuItem
          to="/sales-performance"
          minimal={minimal}
          selected={pathname === "/sales-performance"}
          orange
        >
          <SalesReportIcon />
          {!minimal && <p>Comercial</p>}
        </SectionMenuItem>
        <SectionMenuItem
          to="/dindin"
          minimal={minimal}
          selected={pathname === "/dindin"}
          orange
        >
          <DindinIcon />
          {!minimal && <p>DinDin Virtual</p>}
        </SectionMenuItem>
        <SectionMenuItem
          to="/cnae-enrichments"
          minimal={minimal}
          selected={pathname === "/cnae-enrichments"}
          orange
        >
          <CnaeIcon />
          {!minimal && <p>Enriquecimento CNAE</p>}
        </SectionMenuItem>
        <SectionMenuItem
          to="/opportunities"
          minimal={minimal}
          selected={pathname === "/opportunities"}
          orange
        >
          <IdeoIcon />
          {!minimal && <p>Oportunidades</p>}
        </SectionMenuItem>
        <SectionMenuItem
          to="/distribution-admin"
          minimal={minimal}
          selected={pathname === "/distribution-admin"}
        >
          <IdeoIcon />
          {!minimal && <p>Distribuicao</p>}
        </SectionMenuItem>
        <SectionMenuItem
          to="/register/clients-v2"
          minimal={minimal}
          selected={isOnRegisterRoute}
        >
          <RegisterIcon />
          {!minimal && <p>Cadastro</p>}
        </SectionMenuItem>
        {isOnRegisterRoute &&
          <>
            <MenuItem
              to="/register/buyers"
              minimal={minimal}
              selected={pathname.includes("/register/buyers")}
            >
              <EcommerceIcon />
              {!minimal && <p>Comprador</p>}
            </MenuItem>
            <MenuItem
              to="/register/sellers"
              minimal={minimal}
              selected={pathname === "/register/sellers"}
            >
              <ClientIcon />
              {!minimal && <p>Comercial</p>}
            </MenuItem>
            <MenuItem
              to="/register/clients-v2"
              minimal={minimal}
              selected={pathname === "/register/clients-v2"}
            >
              <ClientIcon />
              {!minimal && <p>Cliente</p>}
            </MenuItem>
            <MenuItem
              to="/register/clients/groups"
              minimal={minimal}
              selected={pathname === "/register/clients/groups"}
            >
              <ClientIcon />
              {!minimal && <p>Grupos de Cliente</p>}
            </MenuItem>
            <MenuItem
              to="/register/shipping"
              minimal={minimal}
              selected={pathname.includes("/register/shipping")}
            >
              <TruckIcon />
              {!minimal && <p>Transportadora</p>}
            </MenuItem>
            <MenuItem
              to="/register/suppliers/all"
              minimal={minimal}
              selected={pathname === "/register/suppliers/all"}
            >
              <RegisterSupplierIcon />
              {!minimal && <p>Representada</p>}
            </MenuItem>
            <MenuItem
              to="/register/vcard"
              minimal={minimal}
              selected={pathname === "/register/vcard"}
            >
              <VcardIcon />
              {!minimal && <p>vCard</p>}
            </MenuItem>
            <MenuItem
              to="/register/banners"
              minimal={minimal}
              selected={pathname === "/register/banners"}
            >
              <BannerIcon />
              {!minimal && <p>Banner (Publicidade)</p>}
            </MenuItem>
            <MenuItem
              to="/register/banner-library"
              minimal={minimal}
              selected={pathname.startsWith("/register/banner-library")}
            >
              <BannerIcon />
              {!minimal && <p>Biblioteca de Banners</p>}
            </MenuItem>
            <MenuItem
              to="/register/admin"
              minimal={minimal}
              selected={pathname === "/register/admin"}
            >
              <AdminIcon />
              {!minimal && <p>Administrador</p>}
            </MenuItem>
          </>
        }
        <SectionMenuItem
          to="/blog/posts"
          minimal={minimal}
          selected={isOnBlogRoute}
        >
          <BlogIcon />
          {!minimal && <p>Blog</p>}
        </SectionMenuItem>
        {isOnBlogRoute &&
          <>
            <MenuItem
              to="/blog/posts"
              minimal={minimal}
              selected={pathname === "/blog/posts"}
            >
              <PostIcon />
              {!minimal && <p>Postagem</p>}
            </MenuItem>
            <MenuItem
              to="/blog/author"
              minimal={minimal}
              selected={pathname === "/blog/author"}
            >
              <AuthorIcon />
              {!minimal && <p>Autor da Postagem</p>}
            </MenuItem>
            <MenuItem
              to="/blog/category"
              minimal={minimal}
              selected={pathname === "/blog/category"}
            >
              <PostCategoryIcon />
              {!minimal && <p>Categoria da Postagem</p>}
            </MenuItem>
          </>
        }
        <SectionMenuItem
          to="/store/products"
          minimal={minimal}
          selected={pathname.includes('store')}
        >
          <EcommerceIcon />
          {!minimal && <p>Loja Online</p>}
        </SectionMenuItem>
        {isOnStoreRoute &&
          <>
            <MenuItem
              to="/store/cupons"
              minimal={minimal}
              selected={pathname.includes('/store/cupons')}
            >
              <CouponIcon />
              {!minimal && <p>Cupons</p>}
            </MenuItem>
            <MenuItem
              to="/store/sales"
              minimal={minimal}
              selected={pathname.includes('/store/sales')}
            >
              <SalesIcon />
              {!minimal && <p>Vendas</p>}
            </MenuItem>
            <MenuItem
              to="/store/products"
              minimal={minimal}
              selected={pathname === "/store/products" || pathname === "/store/products/details"}
            >
              <ProductIcon />
              {!minimal && <p>Produtos</p>}
            </MenuItem>
            <MenuItem
              to="/store/import"
              minimal={minimal}
              selected={pathname === '/store/import' || pathname === '/store/import/new'}
            >
              <ImportingIcon />
              {!minimal && <p>Importação dos Produtos</p>}
            </MenuItem>
            <MenuItem
              to="/store/import/v2"
              minimal={minimal}
              selected={pathname === '/store/import/v2'}
            >
              <ImportingIcon />
              {!minimal && <p>Importar Produtos V2</p>}
            </MenuItem>
            <MenuItem
              to="/store/import/clients"
              minimal={minimal}
              selected={pathname === '/store/import/clients'}
            >
              <ImportingIcon />
              {!minimal && <p>Importação de Clientes</p>}
            </MenuItem>
            <MenuItem
              to="/store/export/clients"
              minimal={minimal}
              selected={pathname === '/store/export/clients'}
            >
              <ImportingIcon />
              {!minimal && <p>Exportação de Clientes</p>}
            </MenuItem>
            <MenuItem
              to="/store/export/products"
              minimal={minimal}
              selected={pathname === '/store/export/products'}
            >
              <ImportingIcon />
              {!minimal && <p>Exportação de Produtos</p>}
            </MenuItem>
            <MenuItem
              to="/store/categories"
              minimal={minimal}
              selected={pathname === '/store/categories'}
            >
              <CategoriesIcon />
              {!minimal && <p>Categoria do Produto</p>}
            </MenuItem>
            <MenuItem
              to="/store/brands"
              minimal={minimal}
              selected={pathname === '/store/brands'}
            >
              <BrandIcon />
              {!minimal && <p>Marca do Produto</p>}
            </MenuItem>
            <MenuItem
              to="/store/highlight_images"
              minimal={minimal}
              selected={pathname === '/store/highlight_images'}
            >
              <HighlightIcon />
              {!minimal && <p>Imagens de Destaque</p>}
            </MenuItem>
            <MenuItem
              to="/store/tags"
              minimal={minimal}
              selected={pathname === '/store/tags'}
            >
              <HighlightIcon />
              {!minimal && <p>Sistema de Tags</p>}
            </MenuItem>
            <MenuItem
              to="/store/landing-page"
              minimal={minimal}
              selected={pathname.includes('/store/landing-page')}
            >
              <BannerIcon />
              {!minimal && <p>Landing Page</p>}
            </MenuItem>
            <MenuItem
              to="/store/suppliers"
              minimal={minimal}
              selected={pathname === '/store/suppliers'}
            >
              <SupplierIcon />
              {!minimal && <p>Representadas</p>}
            </MenuItem>
            <MenuItem
              to="/store/attributes"
              minimal={minimal}
              selected={pathname === '/store/attributes'}
            >
              <CategoriesIcon />
              {!minimal && <p>Atributo</p>}
            </MenuItem>

          </>
        }
        <SectionMenuItem
          to="/finances"
          minimal={minimal}
          selected={isOnFinancesRoute}
        >
          <FinancialIcon />
          {!minimal && <p>Financeiro</p>}
        </SectionMenuItem>
        {isOnFinancesRoute &&
          <>
            <MenuItem
              to="/finances/import-xml"
              minimal={minimal}
              selected={pathname === "/finances/import-xml"}
            >
              <ImportingIcon />
              {!minimal && <p>Importar XML</p>}
            </MenuItem>
            <MenuItem
              to="/finances/import-excel-faturamento"
              minimal={minimal}
              selected={pathname === "/finances/import-excel-faturamento"}
            >
              <ImportingIcon />
              {!minimal && <p>Importar Faturamentos</p>}
            </MenuItem>
            <MenuItem
              to="/finances/import-excel-titulos"
              minimal={minimal}
              selected={pathname === "/finances/import-excel-titulos"}
            >
              <ImportingIcon />
              {!minimal && <p>Importar Títulos</p>}
            </MenuItem>
            <MenuItem
              to="/finances/titles-management"
              minimal={minimal}
              selected={pathname === "/finances/titles-management"}
            >
              <FinancialIcon />
              {!minimal && <p>Gestão de Títulos</p>}
            </MenuItem>
            <MenuItem
              to="/finances/invoices-management"
              minimal={minimal}
              selected={pathname === "/finances/invoices-management"}
            >
              <FinancialIcon />
              {!minimal && <p>Gestão de Faturas</p>}
            </MenuItem>
          </>
        }
        <SectionMenuItem
          to="/support"
          minimal={minimal}
          selected={isOnSupportRoute}
        >
          <SupportIcon />
          {!minimal && <p>Suporte</p>}
        </SectionMenuItem>
        {isOnSupportRoute &&
          <>
            <MenuItem
              to="/support"
              minimal={minimal}
              selected={pathname === "/support"}
            >
              <SupportIcon />
              {!minimal && <p>Central de Suporte</p>}
            </MenuItem>
          </>
        }
        <SectionMenuItem
          to="/settings/info"
          minimal={minimal}
          selected={isOnSettingsRoute}
        >
          <WebsiteInfoIcon />
          {!minimal && <p>Configuração</p>}
        </SectionMenuItem>
        {isOnSettingsRoute &&
          <>
            <MenuItem
              to="/settings/info"
              minimal={minimal}
              selected={pathname === "/settings/info"}
            >
              <WebsiteInfoIcon />
              {!minimal && <p>Info do Site</p>}
            </MenuItem>
            <MenuItem
              to="/settings/client-catalog"
              minimal={minimal}
              selected={pathname === "/settings/client-catalog"}
            >
              <ClientIcon />
              {!minimal && <p>Origens e Tipo de PDV</p>}
            </MenuItem>
            <MenuItem
              to="/settings/map"
              minimal={minimal}
              selected={pathname.includes("/settings/map")}
            >
              <PostCategoryIcon />
              {!minimal && <p>Mapa do Site</p>}
            </MenuItem>
            <MenuItem
              to="/settings/client-api-scripts"
              minimal={minimal}
              selected={pathname === "/settings/client-api-scripts"}
            >
              <ImportingIcon />
              {!minimal && <p>Scripts de Integração</p>}
            </MenuItem>
          </>
        }
      </Container>
    </div>
  );
}
